export default __webpack_public_path__ + "static/media/alerts.383fe051.svg";